import { render, staticRenderFns } from "./DefaultSelect.vue?vue&type=template&id=6dc588cf&scoped=true"
import script from "./DefaultSelect.vue?vue&type=script&lang=js"
export * from "./DefaultSelect.vue?vue&type=script&lang=js"
import style0 from "./DefaultSelect.vue?vue&type=style&index=0&id=6dc588cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc588cf",
  null
  
)

export default component.exports